export default __webpack_public_path__ + "static/media/user.fa4ec743.svg";